import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const piEditIssueEmbedRoute: InvariantJiraRoute = {
	name: 'pi-issue-edit-embed',
	path: '/jira/issues/edit/pi/embed',
};
